import { ElectronApi } from '@/services/electron.api';
import { RemoteLibsService } from '@/services/remote-libs.service';
import generateID from '@/utils/generate-id';
import { imageHasAlpha } from './fs/image.utils';

let pngquantBinaryFile: string | undefined;
let dssimBinaryFile: string | undefined;
let binaryFile: string | undefined;

export const imgutils = {
  // generateLVGL: async (imgPath: string) => {
  //   const { execFile, path, getPath, fs, binaryFile, pngquantBinaryFile } =
  //     await _init();
  //   const tmpPath = path.join(await getPath('temp'), `${generateID()}.png`);
  //   const pngPath = path.join(await getPath('temp'), `${generateID()}.png`);
  //   const binPath = path.join(await getPath('temp'), `${generateID()}.bin`);
  //   await execFile(binaryFile, [
  //     'compress',
  //     imgPath,
  //     tmpPath,
  //     '-f',
  //     'true-color-alpha'
  //   ]);
  //   await execFile(pngquantBinaryFile, [tmpPath, '--output', pngPath]);
  //   await execFile(binaryFile, ['generate-lvgl', pngPath, binPath]);
  //   const binary = await fs.promises.readFile(binPath);
  //   await fs.promises.unlink(binPath);
  //   return binary;
  // },
  decideCompression: async (imgPath: string) => {
    let pngPath = '';
    let tempfilePath = '';
    try {
      const { execFile, path, getPath } = ElectronApi;
      if (!pngquantBinaryFile) {
        pngquantBinaryFile = await new RemoteLibsService().getLibFilename(
          'pngquant'
        );
      }
      if (!dssimBinaryFile) {
        dssimBinaryFile = await new RemoteLibsService().getLibFilename('dssim');
      }
      if (!binaryFile) {
        binaryFile = await new RemoteLibsService().getLibFilename('imgutils');
      }
      if (!path || !pngquantBinaryFile || !dssimBinaryFile || !binaryFile)
        throw '基础库不可以';

      const tempPath = await getPath('temp');

      const tempFileName = generateID() + generateID();
      pngPath = path.join(tempPath, `${tempFileName}.png`);
      tempfilePath = path.join(tempPath, `${tempFileName}_temp.png`);
      await execFile(binaryFile, [
        'compress',
        imgPath,
        pngPath,
        '-f',
        'true-color-alpha'
      ]);
      await execFile(pngquantBinaryFile, [
        '--output',
        tempfilePath,
        '256',
        pngPath
      ]);
      const { stdout } = await execFile(dssimBinaryFile, [
        imgPath,
        tempfilePath
      ]);

      const distance = Number(stdout.split('\t')[0]);
      if (isNaN(distance))
        throw 'Cannot decide compression type: invalid distance';
      if (distance < 0.005) {
        return 'indexed8';
      } else {
        return (await imageHasAlpha(imgPath))
          ? 'true-color-alpha'
          : 'true-color';
      }
    } catch (e) {
      throw 'Cannot decide compression type';
    } finally {
      try {
        if (pngPath) await ElectronApi.fs?.promises.rm(pngPath);
        if (tempfilePath) await ElectronApi.fs?.promises.rm(tempfilePath);
      } catch (error) {
        console.log('');
      }
    }
  }
};
